import { render, staticRenderFns } from "./SellableServiceBookingItemBuilder.vue?vue&type=template&id=754e32fc"
import script from "./SellableServiceBookingItemBuilder.vue?vue&type=script&lang=ts"
export * from "./SellableServiceBookingItemBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports